import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img-web/login/logo.png';
import _imports_1 from '@/assets/img-web/login/success.png';
import _imports_2 from '@/assets/img-web/login/agreement.png';
const _withScopeId = n => (_pushScopeId("data-v-380872a2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-dialog"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "close-icon"
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = {
  key: 0,
  class: "login-container"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1));
const _hoisted_6 = {
  class: "tip-contianer"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1,
  class: "rotate_animate",
  src: "https://huohua-website.huohuaschool.com/assets/img/user/login/button_loading.png"
};
const _hoisted_9 = {
  key: 1,
  class: "password-success"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img-container"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "success-img",
  src: _imports_1
})], -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip-text-send"
}, "新的密码已发送至您的注册邮箱", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tip-text-check"
}, "请前往查看并使用新密码登录", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "agreement-img",
  src: _imports_2
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.dialogVisible = $event),
    "show-close": false,
    width: '320px',
    "close-delay": 100,
    "destroy-on-close": "",
    onClosed: _ctx.closeDialogEvent,
    onOpened: _ctx.opendDialogEvent
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "click-area",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.dialogVis(false))
    }, _hoisted_3), !_ctx.isShowSuccess ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _createElementVNode("form", null, [_createVNode(_component_el_input, {
      placeholder: "请输入邮箱",
      maxlength: "50",
      modelValue: _ctx.email,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.email = $event),
      autocomplete: "off",
      onBlur: _ctx.checkEmail
    }, null, 8, ["modelValue", "onBlur"]), _ctx.isLogin ? (_openBlock(), _createBlock(_component_el_input, {
      key: 0,
      placeholder: "请输入密码",
      maxlength: "16",
      type: "password",
      modelValue: _ctx.password,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.password = $event),
      onBlur: _ctx.checkPassword,
      autocomplete: "off"
    }, null, 8, ["modelValue", "onBlur"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.tipText), 1), _createElementVNode("div", {
      class: "login-btn",
      onClick: _cache[3] || (_cache[3] = (...args) => _ctx.handleLoginSubmitEvent && _ctx.handleLoginSubmitEvent(...args))
    }, [!_ctx.showBtnLoading ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.isLogin ? '登录' : '提交'), 1)) : _createCommentVNode("", true), _ctx.showBtnLoading ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: "forget-password",
      onClick: _cache[4] || (_cache[4] = (...args) => _ctx.changeShowPage && _ctx.changeShowPage(...args))
    }, _toDisplayString(_ctx.isLogin ? '忘记密码' : '返回登录'), 1)])) : _createCommentVNode("", true), _ctx.isShowSuccess ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _hoisted_11, _hoisted_12, _createElementVNode("div", {
      class: "login-btn",
      onClick: _cache[5] || (_cache[5] = (...args) => _ctx.gotoLogin && _ctx.gotoLogin(...args))
    }, "返回登录"), _hoisted_13])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue", "onClosed", "onOpened"])]);
}